import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

class NamedAutocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array),
    initialValue: PropTypes.string
  };

  static defaultProps = {
    suggestions: [],
    initialValue: ""
  };

  constructor(props) {
    super(props);
    this.state = {
      // The active selection's index
      activeSuggestion: -1,
      // The suggestions that match the user's input
      suggestionValues: [],
      // What the user has entered
      userInput: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {

    var isSame = JSON.stringify(prevProps.suggestions.sort()) === JSON.stringify(this.props.suggestions.sort())
    if (!isSame) {
      this.setState({
        // The active selection's index
        activeSuggestion: -1,
        // The suggestions that match the user's input
        suggestionValues: this.props.suggestions,
        // What the user has entered
        userInput: this.props.initialValue
      });
    }
  }

  resetState = () =>{
    this.setState({
      // The active selection's index
      activeSuggestion: -1,
      // The suggestions that match the user's input
      // suggestionValues: [],
      // What the user has entered
      userInput: ""
    });

  };

  onChange = e => {
    const suggestions = this.props.suggestions;
    const userInput = e.currentTarget.value;

    this.setState({
      activeSuggestion: suggestions.findIndex(x=> x.name === userInput),
      suggestionValues: suggestions,
      userInput: e.currentTarget.value
    });

    console.log("clicked");
    const itemValue = this.props.suggestions.find(x=> x.name === userInput);
    this.props.change(itemValue);
  };

  onKeyDown = e => {
    const { activeSuggestion, suggestionValues } = this.state;

    // User pressed the enter key
    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: -1,
        userInput: suggestionValues[activeSuggestion]
      });
    }
    // User pressed the up arrow
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === suggestionValues.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        suggestionValues,
        userInput
      }
    } = this;

    let suggestionsListComponent;

      if (suggestionValues.length) {
        suggestionsListComponent = (
          suggestionValues.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = "suggestion-active";
              }

              return (
                <option className={className} key={suggestion.name} onClick={onClick}>
                  {suggestion.name}
                </option>
              );
            })
        );
      } else {
        suggestionsListComponent = null
      }

    return (
      <Fragment>
        <select
          id="txtSuggest"
          className="form-control"
          placeholder="Select name"
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={userInput}
        >
        <option style={{display:'none'}} value></option>
        {suggestionsListComponent}
        </select>
      </Fragment>
    );
  }
}

export default NamedAutocomplete;
